/**
 * Service Fiscal (Fase 14 - ADR-0032).
 *
 * NF-e via gateway (eNotas / Mock). Ver docs/adr/0032-*.md.
 */

const PREFIXO_NF = "/api/notas-fiscais";
const PREFIXO_CONFIG = "/api/configuracoes-fiscais";

// ============================================================
// Notas Fiscais
// ============================================================

export function listarNotasFiscais(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.pedido) usp.set("pedido", params.pedido);
  if (params.cliente) usp.set("cliente", params.cliente);
  if (params.situacao) usp.set("situacao", params.situacao);
  const qs = usp.toString();
  return request(`${PREFIXO_NF}${qs ? `?${qs}` : ""}`);
}

export function obterNotaFiscal(request, id) {
  return request(`${PREFIXO_NF}/${id}`);
}

export function criarNotaFiscal(request, dados) {
  return request(PREFIXO_NF, { method: "POST", body: JSON.stringify(dados) });
}

export function emitirNotaFiscal(request, id) {
  return request(`${PREFIXO_NF}/${id}/emitir`, { method: "POST" });
}

export function cancelarNotaFiscal(request, id, motivo) {
  return request(`${PREFIXO_NF}/${id}/cancelar`, {
    method: "POST",
    body: JSON.stringify({ motivo }),
  });
}

export function consultarSituacaoNota(request, id) {
  return request(`${PREFIXO_NF}/${id}/consultar`, { method: "POST" });
}

export function listarGatewaysFiscais(request) {
  return request(`${PREFIXO_NF}/gateways`);
}

// M6 (2026-05-26) — NFS-e + CC-e

export function criarNotaFiscalServico(request, dados) {
  return request(`${PREFIXO_NF}/criar-nfse`, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

// M14 (2026-05-27) — NFC-e (modelo 65, varejo PF)

export function criarNotaFiscalConsumidor(request, dados) {
  return request(`${PREFIXO_NF}/criar-nfce`, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function emitirCartaCorrecao(request, notaId, texto, sequencial = null) {
  return request(`${PREFIXO_NF}/${notaId}/emitir-cce`, {
    method: "POST",
    body: JSON.stringify({ texto, sequencial }),
  });
}

export function listarCartasCorrecao(request, notaId) {
  return request(`${PREFIXO_NF}/${notaId}/cartas-correcao`);
}

// ============================================================
// Configuracao Fiscal
// ============================================================

export function listarConfiguracoesFiscais(request) {
  return request(PREFIXO_CONFIG);
}

export function atualizarConfiguracaoFiscal(request, id, dados) {
  return request(`${PREFIXO_CONFIG}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

// ============================================================
// Helpers UI
// ============================================================

export const SITUACOES_NF = [
  { value: "PENDENTE", label: "Pendente", tone: "neutral" },
  { value: "EMITIDA", label: "Emitida", tone: "success" },
  { value: "CANCELADA", label: "Cancelada", tone: "danger" },
  { value: "DENEGADA", label: "Denegada", tone: "danger" },
  { value: "ERRO", label: "Erro", tone: "warning" },
];

// M6 — tipos de documento fiscal
export const TIPOS_DOC_FISCAL = [
  { value: "NFE", label: "NF-e (mercadoria)" },
  { value: "NFSE", label: "NFS-e (serviço)" },
  { value: "NFCE", label: "NFC-e (varejo PF)" },
];
export const TIPO_DOC_FISCAL_LABEL = Object.fromEntries(
  TIPOS_DOC_FISCAL.map((t) => [t.value, t.label]),
);

export const SITUACAO_NF_TONE = Object.fromEntries(
  SITUACOES_NF.map((s) => [s.value, s.tone]),
);
export const SITUACAO_NF_LABEL = Object.fromEntries(
  SITUACOES_NF.map((s) => [s.value, s.label]),
);
